import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getUmpireStats } from "./../actions/reportsActions";
import { getTeamsVolunteering } from '../actions/teamActions';
import UserStatistics from "../components/UserStatistics";

const mapDispatchToProps = dispatch => {
  return {
    getUmpireStats: (seasonId, memberId) => {
      dispatch(getUmpireStats(seasonId, memberId));
    },
    getTeamsVolunteering: (memberId, seasonId) => {
      dispatch(getTeamsVolunteering(memberId, seasonId));
    },
  };
};

const mapStateToProps = state => ({
  memberId: state.user.memberId,
  umpireLevel: state.user.umpireLevel,
  userSeason: state.user.userSeason,
  umpireStats: state.reports.umpireStats,
  fetchingUmpireStatsStatus: state.reports.fetchingUmpireStatsStatus,
  teamsVolunteering: state.user.teamsVolunteering,
  teamsVolunteeringStatus: state.user.teamsVolunteeringStatus,
});

const UserStatisticsContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(UserStatistics));
export default UserStatisticsContainer;



// WEBPACK FOOTER //
// ./src/containers/UserStatisticsContainer.js